import { ComponentProps } from 'react';
import styled from 'styled-components';
import { Text } from '@bpba/ui-components';

type Props = {
  outline?: string;
  tabIndex?: number | undefined;
} & ComponentProps<typeof Text>;

export const FormTitle = styled(Text)<Props>((props) => ({
  outline: props.outline,
}));

FormTitle.defaultProps = {
  color: 'primary.0',
  tabIndex: 0,
  py: '16px',
  outline: 'unset',
};
